<div class="modal-content">
  <div class="modal-header">
    <h6 class="modal-title fw-bold">Duplicate page</h6>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
  </div>

  <form [formGroup]="form" (ngSubmit)="submit()">
    <div class="modal-body">
      <div class="mb-3">
        <label for="domain-select" class="form-label small fw-bold">Domain</label>
        <select id="domain-select" class="form-select" formControlName="domainId">
          <option [ngValue]="null" disabled>Select domain</option>
          @for (domain of availableDomains; track domain.id) {
            <option [ngValue]="domain.id">{{ domain }}</option>
          }
        </select>
      </div>

      <div class="mb-3">
        <label for="slug-input" class="form-label small fw-bold">Slug</label>
        <input formControlName="slug" type="text" class="form-control" id="slug-input" placeholder="Enter slug">
      </div>
    </div>

    <div class="modal-footer bg-tertiary">
      <button type="button" class="btn btn-outline-primary fw-bold" data-bs-dismiss="modal">Cancel</button>

      <button [disabled]="invalid() || submitting" type="submit" class="btn btn-primary fw-bold">
        Duplicate
      </button>
    </div>
  </form>
</div>
